import { createModel } from '@rematch/core';
import { IRootModel } from 'app/store';
import { IModalState } from 'entities/Modal/Modal.models';
import { EModalKey } from 'entities/Modal/Modal.enum';
import { modalReducers } from 'entities/Modal/Modal.reducers';
import { modalEffects } from 'entities/Modal/Modal.effects';

const commonState = { open: false };

export const modal = createModel<IRootModel>()({
  state: {
    [EModalKey.TimeEditor]: commonState,
    [EModalKey.Inactivity]: commonState,
    [EModalKey.Complete]: commonState,
  } as IModalState,
  reducers: modalReducers,
  effects: modalEffects,
});
